import { activeOffer } from './activeOffer';

/** Live website inquiry (F1). Do not use app.notion.com editor URLs or ebd//. */
export const INQUIRY_PROVIDER = 'Notion';
export const INQUIRY_FORM_ID = 'f36bbedc1caa4827badf2b85157b17f0';
export const INQUIRY_HOSTED_URL = `https://datarook.notion.site/${INQUIRY_FORM_ID}`;
export const INQUIRY_EMBED_URL = `https://datarook.notion.site/ebd/${INQUIRY_FORM_ID}`;
export const INQUIRY_EMBED_TITLE = 'Contact form (hosted by Notion)';
export const INQUIRY_MAILTO = activeOffer.fallbackMailto;
export const INQUIRY_LOAD_TIMEOUT_MS = 10000;
export const INQUIRY_NEXT_STEP = activeOffer.nextStep;

export const isUnverifiedIosNotionClient = (
  userAgent = typeof navigator !== 'undefined' ? navigator.userAgent : '',
  platform = typeof navigator !== 'undefined' ? navigator.platform : '',
  maxTouchPoints = typeof navigator !== 'undefined' ? navigator.maxTouchPoints : 0
) => {
  if (/iPad|iPhone|iPod/i.test(userAgent)) {
    return true;
  }
  return platform === 'MacIntel' && maxTouchPoints > 1;
};
